import { useMemo } from 'react';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { useLiveStreamProducts } from './useLiveStreamProducts/useLiveStreamProducts';
import { useVideoProducts } from './useVideoProducts/useVideoProducts';
/**
 *
 */
export const useProducts = () => {
    const video = useStore((state) => state.video);
    const productsFromVideo = useVideoProducts();
    const productsFromLivestream = useLiveStreamProducts();
    const products = useMemo(() => video?.encoded_id
        ? video?.live_stream_id && productsFromLivestream?.length
            ? productsFromLivestream
            : productsFromVideo.length > 0
                ? productsFromVideo
                : undefined
        : undefined, [
        productsFromLivestream,
        productsFromVideo,
        video?.encoded_id,
        video?.live_stream_id,
    ]);
    return {
        products,
    };
};
